import React, { Component, PropTypes } from 'react';
import { withRouter, browserHistory } from 'react-router';
import { connect } from 'react-redux';
import autoBind from 'react-autobind';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import baseTheme from 'material-ui/styles/baseThemes/lightBaseTheme';
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import { setDiscount, clearDiscountsErrors } from '../actions';
import { cyan900, cyan500 } from 'material-ui/styles/colors';
import Alert from '../components/home/Alert';
import Checkbox from 'material-ui/Checkbox';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem'; // eslint-disable-line no-unused-vars
import _ from 'lodash';

const propTypes = {
  dispatch: PropTypes.func,
  isAuthenticated: PropTypes.bool,
  error: PropTypes.any,
  products: PropTypes.array,
  items: PropTypes.array,
  query: PropTypes.object.isRequired,
};


class DiscountNewPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      auth: !props.isAuthenticated,
      alertOpen: false,
      alertMessage: '',
      error: false,
      required: {
        name: null,
        discountType: null,
      },
      discount: {
        name: '',
        triggerMinOrderAmt: 0,
        triggerMinQty: 0,
        triggerByProduct: false,
        triggerAllProducts: false,
        triggerProducts: [],
        triggerByItem: false,
        triggerAllItems: false,
        triggerItems: [],
        discountType: '',
        discountValue: 0,
        discountPercent: 0,
        discountLimitQty: 0,
        discountProducts: [],
        discountItems: [],
        disabled: false,
      },
    };
    autoBind(this);
  }
  getChildContext() {
    return { muiTheme: getMuiTheme(baseTheme) };
  }
  componentWillMount() {
    if (!this.props.isAuthenticated) {
      browserHistory.goBack();
    }
    this.setRequiredParams();
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.error) {
      this.setState({
        alertOpen: true,
        error: true,
        alertMessage: `${nextProps.error.statusCode} ${nextProps.error.error} ${nextProps.error.message}`,
      });
    }
    if (nextProps.discount && !nextProps.error) {
      this.setState({
        alertOpen: true,
        error: false,
        alertMessage: 'Discount saved successfully!',
      });
    }
    this.setRequiredParams();
  }
  setRequiredParams() {
    const required = this.state.required;
    const discount = this.state.discount;
    Object.keys(this.state.required).forEach((paramName) => {
      const param = discount[paramName];
      required[paramName] = (param == null || param.length === 0 || param < 1) ? 'This field is required' : null;
    });
    this.setState({ required });
  }
  handleDiscountTypeChange(event, index, value) {
    const discount = this.state.discount;
    const required = this.state.required;
    delete required.discountValue;
    delete required.discountPercent;
    delete required.discountProducts;
    delete required.discountItems;
    discount.discountType = value;

    switch (discount.discountType) {
      case ('Flat Rate Shipping'):
      case ('Value Off Order'):
        required.discountValue = null;
        break;
      case ('Percent Off Order'):
      case ('Percent Off Shipping'):
        required.discountPercent = null;
        break;
      case ('Value Off Product'):
        required.discountValue = null;
        required.discountProducts = null;
        break;
      case ('Percent Off Product'):
        required.discountPercent = null;
        required.discountProducts = null;
        break;
      case ('Value Off Item'):
        required.discountValue = null;
        required.discountItems = null;
        break;
      case ('Percent Off Item'):
        required.discountPercent = null;
        required.discountItems = null;
        break;
      default:
        break;
    }
    this.setState({
      discount,
      required,
      edited: true,
    });
    this.setRequiredParams();
  }
  handleTriggerChange(e) {
    const required = this.state.required;
    const discount = this.state.discount;

    discount.triggerAllProducts = false;
    discount.triggerByItem = false;
    discount.triggerAllItems = false;
    discount.triggerByProduct = false;
    discount[e.target.name] = e.target.checked;

    if (discount.triggerAllProducts || discount.triggerByProduct) {
      required.triggerProducts = null;
      required.triggerMinQty = null;
    } else {
      delete required.triggerProducts;
    }
    if (discount.triggerByItem || discount.triggerAllItems) {
      required.triggerItems = null;
      required.triggerMinQty = null;
    } else {
      delete required.triggerItems;
    }
    if (!discount.triggerByItem && !discount.triggerAllItems && !discount.triggerAllProducts && !discount.triggerByProduct) {
      delete required.triggerMinQty;
    }

    this.setState({ required,
      discount,
      edited: true });
    this.setRequiredParams();
  }
  handleSelectChange(event, index, value, t) {
    const discount = this.state.discount;
    if (Array.isArray(discount[t])) {
      (discount[t].includes(value)) ? _.pull(discount[t], value) : discount[t].push(value); // eslint-disable-line
    } else {
      discount[t] = value;
    }
    this.setState({
      discount,
      edited: true,
    });
    this.setRequiredParams();
  }
  handleChange(e) {
    const nextState = this.state.discount;
    if (e.target.type === 'checkbox') {
      _.set(nextState, e.target.name, e.target.checked);
    } else {
      _.set(nextState, e.target.name, e.target.value);
    }
    this.setState({
      discounts: nextState,
    });
    this.setRequiredParams();
  }
  handleSubmit() {
    const discount = this.state.discount;
    discount.discountValue = (isNaN(parseInt(discount.discountValue, 10))) ? 0 : discount.discountValue;
    discount.discountPercent = (isNaN(parseInt(discount.discountPercent, 10))) ? 0 : discount.discountPercent;
    this.props.dispatch(clearDiscountsErrors());
    this.props.dispatch(setDiscount(discount));
  }
  handleCancel() {
    this.props.dispatch(clearDiscountsErrors());
    browserHistory.push('/discounts?page=1');
  }
  alertHandleClose() {
    this.setState({
      alertMessage: '',
      alertOpen: false,
    });
    if (!this.state.error) {
      browserHistory.push('/discounts?page=1');
    }
  }
  render() {
    const isTrue = true;
    const triggerProducts = this.state.discount.triggerProducts;
    const productsSelect = _.map(this.props.products, p => <MenuItem
      value={p.id}
      key={p.id}
      label={p.name}
      primaryText={p.name}
      checked={triggerProducts && triggerProducts.includes(p.id)}
    />);
    const triggerDiscountProducts = this.state.discount.discountProducts;
    const discountProductsSelect = _.map(this.props.products, dp => <MenuItem
      value={dp.id}
      key={dp.id}
      label={dp.name}
      primaryText={dp.name}
      checked={triggerDiscountProducts && triggerDiscountProducts.includes(dp.id)}
    />);
    const triggerItems = this.state.discount.triggerItems;
    const itemsSelect = _.map(this.props.items, i => <MenuItem
      value={i.id}
      key={i.id}
      label={i.name}
      primaryText={i.name}
      checked={triggerItems && triggerItems.includes(i.id)}
    />);
    const discountItems = this.state.discount.discountItems;
    const discountItemsSelect = _.map(this.props.items, i => <MenuItem
      value={i.id}
      key={i.id}
      label={i.name}
      primaryText={i.name}
      checked={discountItems && discountItems.includes(i.id)}
    />);
    const styles = {
      floatingLabelStyle: {
        color: cyan900,
      },
      inputStyle: {
        marginRight: '2%',
        width: '250px',
      },
      datePickerStyle: {
        marginRight: '2%',
        width: '250px',
        float: 'left',
      },
      inline: {
        display: 'flex',
        width: '25%',
        float: 'left',
        marginTop: '30px',
      },
      inlineBlock: {
        display: 'inline-block',
        width: '30%',
      },
    };
    return (
      <div className="discounts component">
        <h2>New Discount</h2>
        <Alert
          alertOpen={this.state.alertOpen}
          alertHandleClose={() => this.alertHandleClose()}
          alertMessage={this.state.alertMessage}
        />
        <div className="content">
          <div className="float-right">
            <RaisedButton
              label="Cancel"
              style={{ margin: '20px' }}
              primary
              onClick={this.handleCancel}
            />
            <RaisedButton
              label="Save"
              primary
              onClick={this.handleSubmit}
            />
          </div>
          <br />
          <TextField
            floatingLabelText="Name"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={this.state.discount.name || ''}
            name="name"
            onChange={this.handleChange}
            style={styles.inputStyle}
            errorText={this.state.required.name}
            errorStyle={{ color: cyan500 }}
          />
          <TextField
            floatingLabelText="Minimum Order Amount"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={this.state.discount.triggerMinOrderAmt || 0}
            name="triggerMinOrderAmt"
            onChange={this.handleChange}
            style={styles.inputStyle}
          />
          <br />
          <br />
          <ul>
            <li>
              <Checkbox
                label="Disabled"
                defaultChecked={this.state.discount.disabled}
                name="disabled"
                onCheck={this.handleChange}
              />
            </li>
          </ul>
          <br />
        </div>
        <h2>Trigger</h2>
        <div className="content">
          <div>
            <ul style={styles.inline}>
              <li>
                <Checkbox
                  label="Any Product"
                  name="triggerByProduct"
                  onCheck={this.handleTriggerChange}
                  labelStyle={{ marginLeft: '-12px', width: '90px' }}
                  defaultChecked={this.state.discount.triggerByProduct}
                />
              </li>
              <li>
                <Checkbox
                  label="All Products"
                  name="triggerAllProducts"
                  onCheck={this.handleTriggerChange}
                  labelStyle={{ marginLeft: '-12px', width: '90px' }}
                  defaultChecked={this.state.discount.triggerAllProducts}
                />
              </li>
            </ul>
            <SelectField
              value={this.state.discount.triggerProducts || []}
              multiple={isTrue}
              onChange={(event, index, value) => this.handleSelectChange(event, index, value, 'triggerProducts')}
              floatingLabelText="Trigger Products"
              style={{ verticalAlign: 'bottom', marginRight: '2%', width: '250px' }}
              name="triggerProducts"
              floatingLabelStyle={styles.floatingLabelStyle}
              errorText={this.state.required.triggerProducts}
              errorStyle={{ color: cyan500 }}
            >
              {productsSelect}
            </SelectField>
          </div>
          <div>
            <ul style={styles.inline}>
              <li>
                <Checkbox
                  label="Any Item"
                  name="triggerByItem"
                  onCheck={this.handleTriggerChange}
                  labelStyle={{ marginLeft: '-12px', width: '90px' }}
                  defaultChecked={this.state.discount.triggerByItem}
                />
              </li>
              <li>
                <Checkbox
                  label="All Items"
                  name="triggerAllItems"
                  onCheck={this.handleTriggerChange}
                  labelStyle={{ marginLeft: '-12px', width: '90px' }}
                  defaultChecked={this.state.discount.triggerAllItems}
                />
              </li>
            </ul>
            <SelectField
              value={this.state.discount.triggerItems || []}
              multiple={isTrue}
              onChange={(event, index, value) => this.handleSelectChange(event, index, value, 'triggerItems')}
              floatingLabelText="Trigger Items"
              style={{ display: 'inline-block', verticalAlign: 'bottom', marginRight: '2%', width: '250px' }}
              name="triggerItems"
              floatingLabelStyle={styles.floatingLabelStyle}
              errorText={this.state.required.triggerItems}
              errorStyle={{ color: cyan500 }}
            >
              {itemsSelect}
            </SelectField>
          </div>
          <br />
          <TextField
            floatingLabelText="Minimum Quantity"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={this.state.discount.triggerMinQty || 0}
            name="triggerMinQty"
            onChange={this.handleChange}
            style={styles.inputStyle}
            errorText={this.state.required.triggerMinQty}
            errorStyle={{ color: cyan500 }}
          />
        </div>
        <div style={{ clear: 'left' }} />
        <h2>Discount</h2>
        <div className="content">
          <SelectField
            value={this.state.discount.discountType || ''}
            onChange={(event, index, value) => this.handleDiscountTypeChange(event, index, value)}
            floatingLabelText="Discount Type"
            style={{ verticalAlign: 'bottom', marginRight: '2%', width: '250px' }}
            name="discountType"
            floatingLabelStyle={styles.floatingLabelStyle}
            errorText={this.state.required.discountType}
            errorStyle={{ color: cyan500 }}
          >
            <MenuItem value="Value Off Order" key={1} primaryText="Value Off Order" />
            <MenuItem value="Percent Off Order" key={2} primaryText="Percent Off Order" />
            <MenuItem value="Value Off Product" key={3} primaryText="Value Off Product" />
            <MenuItem value="Percent Off Product" key={4} primaryText="Percent Off Product" />
            <MenuItem value="Value Off Item" key={5} primaryText="Value Off Item" />
            <MenuItem value="Percent Off Item" key={6} primaryText="Percent Off Item" />
            <MenuItem value="Flat Rate Shipping" key={7} primaryText="Flat Rate Shipping" />
            <MenuItem value="Percent Off Shipping" key={8} primaryText="Percent Off Shipping" />
          </SelectField>
          <TextField
            floatingLabelText="Discount Value/Flat Rate"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={this.state.discount.discountValue || 0}
            name="discountValue"
            onChange={this.handleChange}
            style={styles.inputStyle}
            errorText={this.state.required.discountValue}
            errorStyle={{ color: cyan500 }}
          />
          <TextField
            floatingLabelText="Discount Percent"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={this.state.discount.discountPercent || 0}
            name="discountPercent"
            onChange={this.handleChange}
            style={styles.inputStyle}
            errorText={this.state.required.discountPercent}
            errorStyle={{ color: cyan500 }}
          />
          <br />
          <SelectField
            value={this.state.discount.discountProducts || []}
            multiple={isTrue}
            onChange={(event, index, value) => this.handleSelectChange(event, index, value, 'discountProducts')}
            floatingLabelText="Discount Products"
            style={{ verticalAlign: 'bottom', marginRight: '2%', width: '250px' }}
            name="discountProducts"
            floatingLabelStyle={styles.floatingLabelStyle}
            errorText={this.state.required.discountProducts}
            errorStyle={{ color: cyan500 }}
          >
            {discountProductsSelect}
          </SelectField>
          <SelectField
            value={this.state.discount.discountItems || []}
            multiple={isTrue}
            onChange={(event, index, value) => this.handleSelectChange(event, index, value, 'discountItems')}
            floatingLabelText="Discount Items"
            style={{ verticalAlign: 'bottom', marginRight: '2%', width: '250px' }}
            name="discountItems"
            floatingLabelStyle={styles.floatingLabelStyle}
            errorText={this.state.required.discountItems}
            errorStyle={{ color: cyan500 }}
          >
            {discountItemsSelect}
          </SelectField>
          <TextField
            floatingLabelText="Discount Limit Quantity"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={this.state.discount.discountLimitQty || 0}
            name="discountLimitQty"
            onChange={this.handleChange}
            style={styles.inputStyle}
          />
          <br />
          <br />
        </div>
      </div>
    );
  }
}

DiscountNewPage.childContextTypes = {
  muiTheme: PropTypes.object.isRequired,
};

DiscountNewPage.propTypes = propTypes;

function mapStateToProps(state, ownProps) {
  return {
    isAuthenticated: state.auth.isAuthenticated,
    error: state.discounts.error,
    discount: state.discounts.discount,
    products: state.products.results,
    items: state.items.results,
    query: ownProps.location.query,
  };
}

export default withRouter(connect(mapStateToProps)(DiscountNewPage));



// WEBPACK FOOTER //
// ./src/containers/DiscountNewPage.js